import { FileText } from "lucide-react";
import { useOrgStyles } from "./orgUi";

/**
 * A Community Partner whose 501(c)(3) proof isn't uploaded yet (it ticked "we'll upload our
 * proof later" at sign-up, Alicia Oct 22): its Overview asks for it, with the way to Settings,
 * until it's uploaded there.
 */
export default function NonprofitProofBanner({ org, onOpen }) {
    const s = useOrgStyles();
    //old if (org.OrgType !== "nonprofit" || org.Nonprofit501c3ProofFileName) return null;
    // (only one that ticked "later": saying it's a 501(c)(3) is optional since Alicia, Oct 30, and one that didn't
    // sees nothing about it)
    if (org.OrgType !== "nonprofit" || org.Nonprofit501c3ProofFileName || !org.Nonprofit501c3AttestedOn) return null;
    return (
        <div role="status" className={`flex flex-col gap-3 rounded-2xl border p-4 text-sm sm:flex-row sm:items-center sm:justify-between ${s.dark ? "border-amber-800 bg-amber-900/20" : "border-amber-200 bg-amber-50"}`}>
            <p className={`flex items-start gap-2 ${s.text}`}>
                <FileText size={16} className="mt-0.5 flex-shrink-0 text-amber-500" aria-hidden="true" />
                <span><strong>Your 501(c)(3) proof isn't uploaded yet.</strong> Upload your IRS determination letter or other proof in Settings.</span>
            </p>
            <button type="button" className={s.btnPrimary} onClick={onOpen}>Upload in Settings</button>
        </div>
    );
}
